// extracted by mini-css-extract-plugin
export default {"section":"CVPdfSection_section__4C-R4"};